import { Component, inject, Input } from '@angular/core';
import { BulkActionStore } from '../../../stores/bulk.state';
import { DebugComponent } from '../../atoms/debug/debug.component';
import { MenuItem } from 'primeng/api';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-bulk-action-stepper',
  standalone: true,
  imports: [NgIf],
  templateUrl: './bulk-action-stepper.component.html',
  styleUrl: './bulk-action-stepper.component.scss',
})
export class BulkActionStepperComponent {
  @Input() currentEntityMenuItem?: MenuItem;
  @Input() currentActionMenuItem?: MenuItem;
  readonly bulkStore = inject(BulkActionStore);
}
